import * as z from 'zod';

export const signInSchema = z.object({
  email: z.string().email('E-mail inválido').nonempty('E-mail é obrigatório'),
  password: z.string().nonempty('A senha é obrigatória'),
});
